import locales from "../content/locales.json";
import type { LocaleCode } from "./types";

export const PUBLIC_SITE_URL = "https://rauxa.app";
export const readUrlLocale = (search: string): LocaleCode | null => {
  const value = new URLSearchParams(search).get("lang");
  return locales.some(({ code }) => code === value) ? value as LocaleCode : null;
};

export const isPublicPage = (pathname: string): boolean =>
  /^\/(?:home\/?|organize\/?|discover\/?|seny-i-rauxa\/?|careers\/?|race\/[^/]+\/?)?$/.test(pathname);

export const localizedPublicPath = (path: string, locale: LocaleCode): string => {
  const url = new URL(path, PUBLIC_SITE_URL);
  if (locale === "en") url.searchParams.delete("lang");
  else url.searchParams.set("lang", locale);
  return url.pathname + url.search + url.hash;
};

export const publicCanonicalPath = (pathname: string): string =>
  pathname === "/home" ? "/" : pathname.replace(/\/$/, "") || "/";
